import parseQuery from './parseQuery';

export default {
    parseQuery,
    install (Vue, options) {
        Vue.prototype.$parseQuery = parseQuery
    }
}